import { render, staticRenderFns } from "./PreHome.vue?vue&type=template&id=2004df8e&scoped=true"
import script from "./PreHome.vue?vue&type=script&lang=js"
export * from "./PreHome.vue?vue&type=script&lang=js"
import style0 from "./PreHome.vue?vue&type=style&index=0&id=2004df8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2004df8e",
  null
  
)

export default component.exports